const PromoIcon = () => (
  <svg
    width="59"
    height="31"
    viewBox="0 0 59 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="18" y="8" width="41" height="18" rx="9" fill="#0765FF" />
    <path
      d="M29.01 19.02C29.07 20.2 29.99 21.1 31.29 21.1C32.52 21.1 33.46 20.42 33.46 19.3C33.46 18.18 32.61 17.59 31.36 16.95C30.58 16.57 30.02 16.32 30.02 15.58C30.02 15 30.54 14.61 31.18 14.61C31.83 14.61 32.29 15.08 32.35 15.74H33.21C33.15 14.67 32.35 13.8 31.18 13.8C30.06 13.8 29.16 14.51 29.16 15.54C29.16 16.6 29.83 17.06 31.08 17.73C31.93 18.16 32.61 18.52 32.61 19.27C32.61 19.86 32.11 20.29 31.29 20.29C30.6 20.29 29.93 19.88 29.87 19.02H29.01ZM34.193 18.46C34.193 19.92 35.303 21.1 36.753 21.1C37.703 21.1 38.473 20.56 38.793 19.85L38.833 21H39.653V15.94H38.833L38.793 17.09C38.473 16.38 37.703 15.84 36.753 15.84C35.303 15.84 34.193 17.02 34.193 18.46ZM35.053 18.46C35.053 17.48 35.853 16.65 36.883 16.65C37.923 16.65 38.703 17.48 38.703 18.46C38.703 19.46 37.923 20.29 36.883 20.29C35.853 20.29 35.053 19.46 35.053 18.46ZM41.762 13.5H40.902V21H41.762V13.5ZM47.876 18.52C47.876 17.09 46.896 15.84 45.346 15.84C43.846 15.84 42.816 17.02 42.816 18.44C42.816 19.97 43.896 21.1 45.426 21.1C46.756 21.1 47.536 20.22 47.736 19.53L46.976 19.43C46.756 19.88 46.256 20.33 45.426 20.33C44.386 20.33 43.706 19.66 43.676 18.74H47.876V18.52ZM45.346 16.61C46.336 16.61 46.966 17.33 47.016 18.12H43.676C43.706 17.29 44.396 16.61 45.346 16.61Z"
      fill="white"
    />
    <path
      opacity="0.3"
      d="M16.9289 3.36823C17.8645 2.81653 19.0706 3.13972 19.605 4.08528L20.4641 5.60542C20.776 6.15739 21.3378 6.52225 21.969 6.58271L23.7071 6.74922C24.7882 6.85278 25.5741 7.82322 25.4506 8.90227L25.2521 10.637C25.18 11.267 25.4201 11.8924 25.8951 12.3122L27.2035 13.4686C28.0172 14.1879 28.0826 15.4349 27.3484 16.2353L26.1682 17.5221C25.7396 17.9893 25.5662 18.6364 25.7038 19.2553L26.0825 20.9598C26.3181 22.0201 25.638 23.0673 24.5736 23.2833L22.8624 23.6306C22.241 23.7567 21.7204 24.1783 21.4679 24.7598L20.7724 26.3615C20.3398 27.3577 19.1741 27.8052 18.186 27.3543L16.5974 26.6294C16.0206 26.3662 15.3517 26.4013 14.8055 26.7233L13.3015 27.6103C12.3659 28.162 11.1598 27.8388 10.6254 26.8932L9.76633 25.3731C9.4544 24.8211 8.89257 24.4563 8.26144 24.3958L6.5233 24.2293C5.44215 24.1257 4.65631 23.1553 4.77979 22.0762L4.9783 20.3415C5.05038 19.7116 4.81031 19.0861 4.33525 18.6663L3.02694 17.5099C2.21314 16.7906 2.14779 15.5436 2.88194 14.7432L4.06222 13.4565C4.49078 12.9892 4.66417 12.3421 4.52664 11.7232L4.14788 10.0187C3.91228 8.95846 4.59238 7.9112 5.65678 7.69519L7.36799 7.34792C7.98935 7.22182 8.50996 6.80023 8.76249 6.21867L9.45796 4.61706C9.89056 3.62083 11.0563 3.17333 12.0444 3.62421L13.6329 4.34908C14.2097 4.61229 14.8787 4.57723 15.4249 4.25517L16.9289 3.36823Z"
      fill="#FB8200"
    />
    <path
      d="M14.1092 2.40373C14.6617 1.84098 15.5684 1.84098 16.1208 2.40373L18.0413 4.35991C18.3638 4.68842 18.8264 4.83873 19.2804 4.76253L21.9839 4.30875C22.7616 4.17822 23.4951 4.71115 23.6113 5.49115L24.0152 8.20255C24.083 8.65788 24.3689 9.0514 24.781 9.2566L27.2349 10.4786C27.9408 10.8301 28.221 11.6924 27.8565 12.3917L26.5895 14.8227C26.3768 15.2309 26.3768 15.7173 26.5895 16.1256L27.8565 18.5565C28.221 19.2558 27.9408 20.1181 27.2349 20.4697L24.781 21.6916C24.3689 21.8968 24.083 22.2904 24.0152 22.7457L23.6113 25.4571C23.4951 26.2371 22.7616 26.77 21.9839 26.6395L19.2804 26.1857C18.8264 26.1095 18.3638 26.2598 18.0413 26.5883L16.1208 28.5445C15.5684 29.1073 14.6617 29.1073 14.1092 28.5445L12.1888 26.5883C11.8663 26.2598 11.4036 26.1095 10.9496 26.1857L8.24615 26.6395C7.46842 26.77 6.73491 26.2371 6.61872 25.4571L6.21486 22.7457C6.14704 22.2904 5.86113 21.8968 5.44904 21.6916L2.99515 20.4697C2.28923 20.1181 2.00905 19.2558 2.37353 18.5565L3.64052 16.1256C3.85328 15.7173 3.85329 15.2309 3.64052 14.8227L2.37353 12.3917C2.00905 11.6924 2.28923 10.8301 2.99515 10.4786L5.44904 9.2566C5.86113 9.0514 6.14704 8.65788 6.21486 8.20255L6.61872 5.49115C6.73491 4.71115 7.46842 4.17822 8.24615 4.30875L10.9496 4.76253C11.4036 4.83873 11.8663 4.68842 12.1888 4.35991L14.1092 2.40373Z"
      fill="#FB8200"
    />
    <path
      d="M11.2948 14.9125C12.5915 14.9125 13.6205 13.8835 13.6205 12.5868C13.6205 11.2901 12.5915 10.2612 11.2948 10.2612C9.99808 10.2612 8.96915 11.2901 8.96915 12.5868C8.96915 13.8835 9.99808 14.9125 11.2948 14.9125ZM19.6249 10.4021H17.6657L10.1108 20.4095H12.07L19.6249 10.4021ZM11.2948 13.3902C10.8297 13.3902 10.4914 13.0519 10.4914 12.5868C10.4914 12.1217 10.8297 11.7693 11.2948 11.7693C11.7599 11.7693 12.1123 12.1217 12.1123 12.5868C12.1123 13.0519 11.7599 13.3902 11.2948 13.3902ZM18.5819 20.5504C19.8786 20.5504 20.9075 19.5215 20.9075 18.2248C20.9075 16.928 19.8786 15.8991 18.5819 15.8991C17.2851 15.8991 16.2562 16.928 16.2562 18.2248C16.2562 19.5215 17.2851 20.5504 18.5819 20.5504ZM18.5819 19.0282C18.1167 19.0282 17.7644 18.6899 17.7644 18.2248C17.7644 17.7596 18.1167 17.4073 18.5819 17.4073C19.0329 17.4073 19.3853 17.7596 19.3853 18.2248C19.3853 18.6899 19.0329 19.0282 18.5819 19.0282Z"
      fill="white"
    />
  </svg>
);

export default PromoIcon;

export const normal = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6667 8H12L10 14L6.00004 2L4.00004 8H1.33337"
      stroke="#667085"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const hamburger = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M3 7H21Z" fill="white" />
    <path d="M3 7H21" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
    <path
      d="M3 12H21"
      stroke="#FCFDFD"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M3 17H21"
      stroke="#FCFDFD"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const starIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6443_117083)">
      <path
        d="M9.07668 2.71993C9.41827 1.89864 10.5817 1.89864 10.9233 2.71993L12.4105 6.29546C12.5545 6.6417 12.8801 6.87827 13.2539 6.90823L17.114 7.2177C18.0006 7.28878 18.3601 8.39529 17.6846 8.97396L14.7436 11.4932C14.4588 11.7372 14.3345 12.1199 14.4215 12.4847L15.32 16.2515C15.5264 17.1167 14.5851 17.8006 13.826 17.3369L10.5213 15.3184C10.2012 15.1229 9.79876 15.1229 9.47875 15.3184L6.17397 17.3369C5.41487 17.8006 4.47362 17.1167 4.68001 16.2515L5.57852 12.4847C5.66553 12.1199 5.54116 11.7372 5.25637 11.4932L2.31539 8.97396C1.63985 8.39529 1.99938 7.28878 2.88603 7.2177L6.74612 6.90823C7.11991 6.87827 7.44552 6.6417 7.58953 6.29546L9.07668 2.71993Z"
        fill="#F2F4F7"
      />
      <g clipPath="url(#clip1_6443_117083)">
        <path
          d="M9.07668 2.71993C9.41827 1.89864 10.5817 1.89864 10.9233 2.71993L12.4105 6.29546C12.5545 6.6417 12.8801 6.87827 13.2539 6.90823L17.114 7.2177C18.0006 7.28878 18.3601 8.39529 17.6846 8.97396L14.7436 11.4932C14.4588 11.7372 14.3345 12.1199 14.4215 12.4847L15.32 16.2515C15.5264 17.1167 14.5851 17.8006 13.826 17.3369L10.5213 15.3184C10.2012 15.1229 9.79876 15.1229 9.47875 15.3184L6.17397 17.3369C5.41487 17.8006 4.47362 17.1167 4.68001 16.2515L5.57852 12.4847C5.66553 12.1199 5.54116 11.7372 5.25637 11.4932L2.31539 8.97396C1.63985 8.39529 1.99938 7.28878 2.88603 7.2177L6.74612 6.90823C7.11991 6.87827 7.44552 6.6417 7.58953 6.29546L9.07668 2.71993Z"
          fill="#FD853A"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_6443_117083">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip1_6443_117083">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const backArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.52398 9.1664H16.6673V10.8331H6.52398L10.994 15.3031L9.81565 16.4814L3.33398 9.99973L9.81565 3.51807L10.994 4.6964L6.52398 9.1664Z"
      fill="#2F2B43"
      fillOpacity="0.6"
    />
  </svg>
);

export const forwardArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M13.4773 9.1664L9.00732 4.6964L10.1857 3.51807L16.6673 9.99973L10.1857 16.4814L9.00732 15.3031L13.4773 10.8331H3.33398V9.1664H13.4773Z"
      fill="#2F2B43"
      fillOpacity="0.6"
    />
  </svg>
);



export const WidgetChatIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4"
          d="M17.98 10.79V14.79C17.98 15.05 17.97 15.3 17.94 15.54C17.71 18.24 16.12 19.58 13.19 19.58H12.79C12.54 19.58 12.3 19.7 12.15 19.9L10.95 21.5C10.42 22.21 9.56 22.21 9.03 21.5L7.82999 19.9C7.69999 19.73 7.41 19.58 7.19 19.58H6.79001C3.60001 19.58 2 18.79 2 14.79V10.79C2 7.86001 3.35001 6.27001 6.04001 6.04001C6.28001 6.01001 6.53001 6 6.79001 6H13.19C16.38 6 17.98 7.60001 17.98 10.79Z"
          fill="#fff" />
    <path
      d="M9.99023 14C9.43023 14 8.99023 13.55 8.99023 13C8.99023 12.45 9.44023 12 9.99023 12C10.5402 12 10.9902 12.45 10.9902 13C10.9902 13.55 10.5502 14 9.99023 14Z"
      fill="#fff" />
    <path
      d="M13.4902 14C12.9302 14 12.4902 13.55 12.4902 13C12.4902 12.45 12.9402 12 13.4902 12C14.0402 12 14.4902 12.45 14.4902 13C14.4902 13.55 14.0402 14 13.4902 14Z"
      fill="#fff" />
    <path
      d="M6.5 14C5.94 14 5.5 13.55 5.5 13C5.5 12.45 5.95 12 6.5 12C7.05 12 7.5 12.45 7.5 13C7.5 13.55 7.05 14 6.5 14Z"
      fill="#fff" />
    <path
      d="M21.98 6.79001V10.79C21.98 13.73 20.63 15.31 17.94 15.54C17.97 15.3 17.98 15.05 17.98 14.79V10.79C17.98 7.60001 16.38 6 13.19 6H6.79004C6.53004 6 6.28004 6.01001 6.04004 6.04001C6.27004 3.35001 7.86004 2 10.79 2H17.19C20.38 2 21.98 3.60001 21.98 6.79001Z"
      fill="#fff" />
  </svg>

);

export const WidgetEmailIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4"
          d="M7 3H17C20 3 22 4.5 22 8V11.14C22 11.87 21.25 12.33 20.58 12.04C19.48 11.56 18.23 11.38 16.92 11.59C14.3 12.02 12.16 14.09 11.63 16.69C11.48 17.45 11.46 18.19 11.56 18.9C11.64 19.49 11.16 20.01 10.57 20.01H7C4 20.01 2 18.51 2 15.01V8.01001C2 4.50001 4 3 7 3Z"
          fill="#fff" />
    <path
      d="M11.9998 11.87C11.1598 11.87 10.3098 11.61 9.65978 11.08L6.52978 8.57996C6.20978 8.31996 6.14978 7.84997 6.40978 7.52997C6.66978 7.20997 7.13977 7.14997 7.45977 7.40997L10.5898 9.90997C11.3498 10.52 12.6398 10.52 13.3998 9.90997L16.5298 7.40997C16.8498 7.14997 17.3298 7.19997 17.5798 7.52997C17.8398 7.84997 17.7898 8.32996 17.4598 8.57996L14.3298 11.08C13.6898 11.61 12.8398 11.87 11.9998 11.87Z"
      fill="#fff" />
    <path
      d="M18 13C15.24 13 13 15.23 13 18C13 20.76 15.24 23 18 23C20.77 23 23 20.76 23 18C23 15.23 20.77 13 18 13ZM20.05 17.55L19.68 17.91L17.51 20.09C17.41 20.18 17.22 20.28 17.08 20.3L16.1 20.44C15.75 20.49 15.5 20.24 15.55 19.89L15.69 18.91C15.71 18.77 15.8 18.58 15.9 18.48L18.08 16.31L18.44 15.94C18.68 15.7 18.95 15.54 19.23 15.54C19.47 15.54 19.74 15.65 20.04 15.94C20.7 16.6 20.49 17.11 20.05 17.55Z"
      fill="#fff" />
  </svg>

);

export const WhatAppIcon = () => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.52094 0.5H6.80094C6.20094 0.53 5.42094 0.56 5.09094 0.65C4.55094 0.77 4.04094 0.92 3.62094 1.13C3.14094 1.37 2.69094 1.7 2.30094 2.09C1.91094 2.48 1.61094 2.9 1.34094 3.41C1.13094 3.83 0.950938 4.34 0.860938 4.85C0.800938 5.21 0.740938 5.99 0.710938 6.59V21.2C0.740938 21.8 0.770937 22.58 0.860938 22.91C0.980938 23.45 1.13094 23.96 1.34094 24.38C1.58094 24.86 1.91094 25.31 2.30094 25.7C2.69094 26.09 3.11094 26.39 3.62094 26.66C4.04094 26.87 4.55094 27.05 5.06094 27.14C5.42094 27.2 6.20094 27.26 6.80094 27.29H21.4109C22.0109 27.26 22.7909 27.23 23.1209 27.14C23.6609 27.02 24.1709 26.87 24.5909 26.66C25.0709 26.42 25.5209 26.09 25.9109 25.7C26.3009 25.31 26.6009 24.89 26.8709 24.38C27.0809 23.96 27.2609 23.45 27.3509 22.94C27.4109 22.58 27.4709 21.8 27.5009 21.2V6.59C27.4709 5.99 27.4409 5.21 27.3509 4.88C27.2309 4.34 27.0809 3.83 26.8709 3.41C26.6309 2.93 26.3009 2.48 25.9109 2.09C25.5209 1.7 25.1009 1.4 24.5909 1.13C24.1709 0.92 23.6609 0.74 23.1509 0.65C22.7909 0.59 22.0109 0.53 21.4109 0.5H7.52094Z"
      fill="url(#paint0_linear_8153_146865)"
    />
    <path
      d="M18.9817 15.3203C18.7417 15.2003 17.5417 14.6303 17.3317 14.5403C17.1217 14.4503 16.9417 14.4203 16.7917 14.6603C16.6417 14.9003 16.1617 15.4403 16.0417 15.5903C15.8917 15.7403 15.7717 15.7703 15.5317 15.6503C15.2917 15.5303 14.5117 15.2903 13.5817 14.4803C12.8617 13.8503 12.3817 13.0703 12.2317 12.8303C12.0817 12.5903 12.2317 12.4703 12.3517 12.3503C12.4717 12.2303 12.5917 12.0803 12.7117 11.9303C12.8317 11.7803 12.8617 11.6903 12.9517 11.5403C13.0417 11.3903 12.9817 11.2403 12.9217 11.1203C12.8617 11.0003 12.3817 9.83031 12.1717 9.35031C11.9617 8.90031 11.7817 8.96031 11.6317 8.93031H11.1817C11.0317 8.93031 10.7617 8.99031 10.5517 9.23031C10.3417 9.47031 9.71172 10.0403 9.71172 11.2103C9.71172 12.3803 10.5817 13.4903 10.7017 13.6703C10.8217 13.8203 12.4117 16.2203 14.8117 17.2403C15.3817 17.4803 15.8317 17.6303 16.1917 17.7503C16.7617 17.9303 17.3017 17.9003 17.7217 17.8403C18.1717 17.7803 19.1617 17.2703 19.3417 16.7303C19.5517 16.1903 19.5517 15.7103 19.4917 15.6203C19.3717 15.5003 19.2217 15.4403 18.9817 15.3203ZM14.3917 21.5003C12.9517 21.5003 11.5717 21.1103 10.3417 20.3903L10.0417 20.2103L7.04172 20.9903L7.85172 18.0803L7.67172 17.7803C6.89172 16.5203 6.47172 15.0803 6.47172 13.5803C6.47172 9.23031 10.0417 5.69031 14.4217 5.69031C16.4917 5.69031 18.5017 6.50031 20.0017 8.00031C21.5017 9.50031 22.3117 11.4803 22.3117 13.5803C22.3117 17.9303 18.7417 21.5003 14.3917 21.5003ZM21.1417 6.86031C19.3417 5.06031 16.9417 4.07031 14.3917 4.07031C9.14172 4.07031 4.85172 8.33031 4.85172 13.5803C4.85172 15.2603 5.30172 16.8803 6.11172 18.3203L4.76172 23.2403L9.80172 21.9203C11.1817 22.6703 12.7717 23.0903 14.3617 23.0903C19.6117 23.0903 23.9017 18.8303 23.9017 13.5803C23.9317 11.0603 22.9417 8.66031 21.1417 6.86031Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8153_146865"
        x1="14.1149"
        y1="0.506"
        x2="14.1149"
        y2="27.272"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#62FA7F" />
        <stop offset="0.686" stopColor="#22CC40" />
        <stop offset={1} stopColor="#05B723" />
      </linearGradient>
    </defs>
  </svg>
);
